import React from "react";

export default function Whychoiseus() {
  return (
    <div>
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
          <div
            className="section-title text-center position-relative pb-3 mb-5 mx-auto"
            style={{ maxwidth: "600px" }}
          >
            <h5 className="fw-bold text-primary text-uppercase">
              Why Choose Us
            </h5>
            <h1 className="mb-0">
              We Are Here to Accelerate Your Business Growth Efficiently
            </h1>
          </div>
          <div className="row g-5">
            {/* Left Column */}
            <div className="col-lg-4">
              <div className="row g-5">
                {/* Proven Lead Generation Expertise */}
                <div className="col-12 wow zoomIn" data-wow-delay="0.2s">
                  <div
                    className="bg-primary rounded d-flex align-items-center justify-content-center mb-3"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <i className="fa fa-bullseye text-white"></i>
                  </div>
                  <h4>Proven Lead Generation Expertise</h4>
                  <p className="mb-0">
                    With strategic campaigns and advanced tools, we deliver
                    high-quality leads that convert — helping your business grow
                    faster and smarter.
                  </p>
                </div>

                {/* Skilled & Dedicated Team */}
                <div className="col-12 wow zoomIn" data-wow-delay="0.6s">
                  <div
                    className="bg-primary rounded d-flex align-items-center justify-content-center mb-3"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <i className="fa fa-users text-white"></i>
                  </div>
                  <h4>Skilled & Dedicated Team</h4>
                  <p className="mb-0">
                    Our team of experts brings years of experience in sales,
                    marketing, and client acquisition, ensuring every campaign
                    drives real business results.
                  </p>
                </div>
              </div>
            </div>

            {/* Center Image */}
            <div
              className="col-lg-4 wow zoomIn"
              data-wow-delay="0.9s"
              style={{ minHeight: "350px" }}
            >
              <div className="position-relative h-100">
                <img
                  className="position-absolute w-100 h-100 rounded wow zoomIn"
                  data-wow-delay="0.1s"
                  src="assets/img/mppwhy.png"
                  alt="Feature"
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>

            {/* Right Column */}
            <div className="col-lg-4">
              <div className="row g-5">
                {/* Data-Driven Strategies */}
                <div className="col-12 wow zoomIn" data-wow-delay="0.4s">
                  <div
                    className="bg-primary rounded d-flex align-items-center justify-content-center mb-3"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <i className="fa fa-chart-line text-white"></i>
                  </div>
                  <h4>Data-Driven Strategies</h4>
                  <p className="mb-0">
                    At My Easy Tax Pro Partners, we use insights and analytics
                    to create performance-focused solutions tailored to your
                    goals.
                  </p>
                </div>

                {/* Continuous Support & Optimization */}
                <div className="col-12 wow zoomIn" data-wow-delay="0.8s">
                  <div
                    className="bg-primary rounded d-flex align-items-center justify-content-center mb-3"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <i className="fa fa-headset text-white"></i>
                  </div>
                  <h4>Continuous Support & Optimization</h4>
                  <p className="mb-0">
                    We don’t just deliver leads — we nurture your growth with
                    constant monitoring, updates, and 24/7 assistance to keep
                    your sales pipeline strong.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
